{
  "takim": {
    "Baslik": "Teams",
    "Liste": "Team List",
    "Yeni Ekle": "Add New Team",
    "Ara": "Search",
    "Temizle": "Clear",
    "Yenile": "Refresh",
    "Duzenle": "Edit",
    "Sil": "Delete",
    "Durum": "Status",
    "Kullanici Ata": "Assign Staff",
    "Ad": "Team Name",
    "Kayit Sil": "Delete Record",
    "Sil Onay": "Are you sure you want to delete this team? All users in the team will also be removed.",
    "Iptal": "Cancel",
    "Kaydet": "Save",
    "Guncelle": "Update",
    "Aktif": "Active",
    "Pasif": "Passive",
    "Ekle": "Add",
    "Yonetici": "Is Manager?",
    "Tümü": "All",
    "Kapat": "Close",
    "Personeller": "Staff in Team",
    "Personel Secin": "Select Staff...",
    "Henuz Personel Yok": "No staff in team yet."
  },
  "takim_hedef": {
    "Baslik": "Takım Hedef Tanımları",
    "Firma-Ürün": "Firma-Ürün",
    "Satış Group": "Satış Group",
    "Tutar": "Tutar",
    "Ekle": "Hedef Ekle",
    "Hedef Ekle": "Yeni Hedef Tanımla",
    "Hedef Güncelle": "Hedef Güncelle",
    "Düzeltme": "Düzeltme",
    "Sil": "Sil",
    "Data Yenile": "Verileri Güncelle",
    "Örn": "Örnek",
    "Kaydet": "Kaydet",
    "Güncelle": "Güncelle",
    "İptal": "İptal",
    "Ürün": "Ürün",
    "Seçiniz": "Seçiniz"
  }
}
